import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';
@Pipe({
  name: 'abbreviateNumber'
})
export class AbbreviateNumberPipe implements PipeTransform {
  /**
   * Transforms a large number into an abbreviated format with currency symbol
   * @param value - The number to transform
   * @param currencyCode - The currency code (e.g., 'USD', 'NGN')
   * @param display - 'symbol' or 'code' (default: 'symbol')
   * @returns Formatted string like '$1.5B' or 'NGN 1.5B'
   */
  transform(value: number, currencyCode: string = 'USD', display: string = 'symbol'): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }
    const absValue = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    let symbol = currencyCode;
    if (display === 'symbol') {
      symbol = getCurrencySymbol(currencyCode, 'narrow') || currencyCode;
    }
    const trillion = 1_000_000_000_000;
    const billion = 1_000_000_000;
    let formattedValue: string;
    if (absValue >= trillion) {
      formattedValue = this.formatWithDecimal(absValue / trillion) + 'T';
    } else if (absValue >= billion) {
      formattedValue = this.formatWithDecimal(absValue / billion) + 'B';
    } else {
      formattedValue = absValue.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
    return `${sign}${symbol}${formattedValue}`;
  }
  private formatWithDecimal(num: number): string {
    if (num >= 100) {
      return Math.round(num).toString();
    } else if (num >= 10) {
      return num.toFixed(1).replace(/\.0$/, '');
    } else {
      return num.toFixed(2).replace(/\.?0+$/, '');
    }
  }
}
